import Encoding from "encoding-japanese";
const $ = (s: string) => document.querySelector(s) as HTMLElement;
const input = $("#input") as HTMLTextAreaElement;
const output = $("#output") as HTMLTextAreaElement;

function str2codes(s: string) { return Encoding.stringToCode(s); }
function codes2str(codes: number[]) { return Encoding.codeToString(codes); }

function utf8ToSjis(s: string) {
  const u = str2codes(s);
  const sjis = Encoding.convert(u, "SJIS", "UNICODE");
  return codes2str(Encoding.convert(sjis, "UNICODE", "SJIS"));
}

function sjisToUtf8(s: string) {
  const bin = str2codes(s);
  const utf8 = Encoding.convert(bin, "UNICODE", "SJIS");
  return codes2str(utf8);
}

function htmlEncode(s: string) {
  return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\"/g,"&quot;").replace(/'/g,"&#39;");
}
function htmlDecode(s: string) {
  const e = document.createElement("textarea"); e.innerHTML = s; return e.value;
}
function b64Encode(s: string) { return btoa(unescape(encodeURIComponent(s))); }
function b64Decode(s: string) { return decodeURIComponent(escape(atob(s))); }

function toLF(s: string){ return s.replace(/\r\n/g, "\n"); }
function toCRLF(s: string){ return s.replace(/(?<!\r)\n/g, "\r\n"); }
function addBOM(s: string){ return "\uFEFF" + s; }
function dropBOM(s: string){ return s.replace(/^\uFEFF/, ""); }

// 文字化け修復（簡易）：各候補をスコアリング（不可視率）して最良を提示
function repair(s: string){
  const candidates = [
    sjisToUtf8(utf8ToSjis(s)), // UTF-8 を SJIS と誤読 → 直す
    utf8ToSjis(sjisToUtf8(s))  // SJIS を UTF-8 と誤読 → 直す（参考）
  ];
  const score = (t: string) => (t.match(/[\u0000-\u001F\u007F]/g)?.length ?? 0);
  const best = candidates.reduce((a, b) => score(a) <= score(b) ? a : b);
  return best;
}

// Events
$("#utf8ToSjis")?.addEventListener("click", ()=> output.value = utf8ToSjis(input.value));
$("#sjisToUtf8")?.addEventListener("click", ()=> output.value = sjisToUtf8(input.value));
$("#urlEncode") ?.addEventListener("click", ()=> output.value = encodeURIComponent(input.value));
$("#urlDecode") ?.addEventListener("click", ()=> output.value = decodeURIComponent(input.value));
$("#htmlEncode")?.addEventListener("click", ()=> output.value = htmlEncode(input.value));
$("#htmlDecode")?.addEventListener("click", ()=> output.value = htmlDecode(input.value));
$("#b64Encode") ?.addEventListener("click", ()=> output.value = b64Encode(input.value));
$("#b64Decode") ?.addEventListener("click", ()=> output.value = b64Decode(input.value));
$("#toLF")      ?.addEventListener("click", ()=> output.value = toLF(input.value));
$("#toCRLF")    ?.addEventListener("click", ()=> output.value = toCRLF(input.value));
$("#bomAdd")    ?.addEventListener("click", ()=> output.value = addBOM(input.value));
$("#bomDrop")   ?.addEventListener("click", ()=> output.value = dropBOM(input.value));
$("#repair")    ?.addEventListener("click", ()=> output.value = repair(input.value));

$("#btnCopy")?.addEventListener("click", async ()=> {
  await navigator.clipboard.writeText(output.value);
  alert("コピーしました");
});
$("#btnDownload")?.addEventListener("click", ()=> {
  const blob = new Blob([output.value], {type:"text/plain;charset=utf-8"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = "converted.txt"; a.click();
  URL.revokeObjectURL(url);
});
$("#btnClear")?.addEventListener("click", ()=> input.value = "");
$("#btnPaste")?.addEventListener("click", async ()=> input.value = await navigator.clipboard.readText());